import { css } from '@linaria/core';
import { baseUnits, breakpoints } from 'styles/utils';
export const withStickyClass = "odules__User__styles_ts-withStickyClass-w17nt3dl";
export const stickyHeaderClass = "odules__User__styles_ts-stickyHeaderClass-slbihyr";
export const listWrapper = "odules__User__styles_ts-listWrapper-l2sijdr";
export const extraPadding = "odules__User__styles_ts-extraPadding-e5qnv94";
export const navTabsPadding = "odules__User__styles_ts-navTabsPadding-nf2fab8";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");